import * as React from 'react';
// import { prevent } from 'common/prevent';
import { useRootStore } from 'mst';
import { VSpacer } from 'naan/primitives/spacer';
import { styled } from 'naan/stitches.config';
import { InteractiveTag, TagsContainer } from 'naan/primitives/tags';
import { Text } from 'naan/primitives/text';
import { AnimatedTagsContainer } from './animated-tags-container';
import { FilterBox } from './filter-box';

type RootStore = {
  storyManager: {
    ibTagsList: string[];
    apTagsList: string[];
  };
};

type Props = {
  show: boolean;
};

const ThemesFilterPanelWrapper = styled('div', {
  maxWidth: '960px',
  margin: '0 auto',
});

export const ThemesFilterPanel = ({ show = false }: Props) => {
  const store = useRootStore() as RootStore;
  const { storyManager } = store ?? {};

  return (
    <AnimatedTagsContainer show={show}>
      <ThemesFilterPanelWrapper>
        <VSpacer size={2} />
        <Text textStyle="tiny-text" color={'textSecondary'}>
          AP THEMES
        </Text>
        <TagsContainer>
          <FilterBox
            filterItems={storyManager.apTagsList}
            filterQueryKey={'themes'}
            renderFilterControl={(item, selected, action) => {
              return (
                <InteractiveTag
                  role="button"
                  selected={selected}
                  onSelect={action}
                  type="topic"
                >
                  {item}
                </InteractiveTag>
              );
            }}
          />
        </TagsContainer>
        <VSpacer size={2} />
        <Text textStyle="tiny-text" color={'textSecondary'}>
          IB THEMES
        </Text>
        <TagsContainer>
          <FilterBox
            filterItems={storyManager.ibTagsList}
            filterQueryKey={'themes'}
            renderFilterControl={(item, selected, action) => {
              return (
                <InteractiveTag
                  role="button"
                  selected={selected}
                  onSelect={action}
                  type="topic"
                >
                  {item}
                </InteractiveTag>
              );
            }}
          />
        </TagsContainer>
      </ThemesFilterPanelWrapper>
    </AnimatedTagsContainer>
  );
};
